define("powergen/adapters/game",
  [],
  function() {
    "use strict";
    var GameAdapter;

    GameAdapter = DS.RESTAdapter.extend({
      find: function(store, type, id) {
        return $.getJSON("json/game-" + id + ".json");
      }
    });


    return GameAdapter;
  });